import React from "react";
// import successIcon from "../../assets/tick-mark.svg";

const SuccessPopup = ({ showPopUp, message = "Successfully Done!", onClose }) => {
  if (!showPopUp) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
      <div className="relative w-[49.92rem] h-[20.58rem] rounded-[0.625rem] bg-[#051E1C] shadow-lg flex flex-col items-center justify-center">

        {/* Close Icon */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white text-xl hover:opacity-80"
        >
          ✕
        </button>

        {/* Success Icon */}
        <img
          src="assets/tick-mark.svg"
          alt="Success"
          className="mb-6 w-[4.33rem] h-[4.33rem] object-contain mt-[3rem] mx-[22.75rem]"
        />


        {/* Message */}
        <p className="text-center text-white font-semibold text-base sm:text-lg md:text-xl leading-relaxed">
          {message}
        </p>
      </div>
    </div>
  );
};

export default SuccessPopup;
